import { AutogenModelTopmatchProfile, AutogenRowTopmatchProfile } from "./autogen/AutogenModelTopMatchProfile";

export class ModelTopMatchProfile extends AutogenModelTopmatchProfile<RowTopmatchProfile> {
    constructor() {
        super(RowTopmatchProfile);
    }
}

export class RowTopmatchProfile extends AutogenRowTopmatchProfile {
}